import { Box, Typography } from '@mui/material'
import React from 'react'
import { sendParameters } from '../../../common/functions'
import FileUpload from '../../../components/file/FileUpload'
import FileViewWidget from '../../../components/file/FileView'
import TaskWrapper from './TaskWrapper'

export default function InitialCalculationWidget({ task, isCanceled }) {
  const [files, setFiles] = React.useState([])

  const enabled = task.isActive && task.accessFlags.update && !isCanceled

  return (
    <TaskWrapper
      task={task}
      isCanceled={isCanceled}
      label="Финансово-экономический отдел"
      onSave={() => sendParameters(task.paidServiceId, task.id, {}, files)}
    >
      <Box display="flex" flexDirection="column" gap={3}>
        <Typography variant="subtitle1" color="black">
          Калькуляция
        </Typography>
        {enabled ? (
          <FileUpload
            files={files}
            onUpload={(file) => setFiles([...files, file])}
            onDelete={(id) => setFiles(files.filter((file) => file.id === id))}
          />
        ) : (
          <FileViewWidget files={task.files} />
        )}
      </Box>
    </TaskWrapper>
  )
}
